import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import "./CartPage.css";
import SEO from "../components/SEO";

export default function CartPage() {
  const { cart, removeItem, updateQuantity, totalPrice } = useCart();

  const getCategoryLabel = (item) => {
    if (item.type === "certificate") return "Сертифікат";
    return item.categoryObj?.name || null;
  };

  const getProductLink = (item) => {
    if (item.type === "certificate") return null;
    return `/product/${item.id}`;
  };

  if (cart.length === 0) {
    return (
      <div className="cart-empty page-enter">
        <SEO title="Кошик" description="кошик порожній" url="https://zori.place/cart" />
        <div className="container">
          <div className="cart-empty-inner">
            <span>🛒</span>
            <h2>Кошик порожній</h2>
            <p>Додайте товари з каталогу, щоб розпочати покупку</p>
            <Link to="/catalog" className="btn-primary">
              Перейти до каталогу
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page page-enter">
      <SEO
        title="Кошик"
        description="Кошик з товарами з zori.place"
        url="https://zori.place/cart"
      />
      <div className="container">
        <h1 className="cart-title">Кошик</h1>

        <div className="cart-layout">
          <div className="cart-items">
            {cart.map((item) => {
              const imageUrl = item.images?.[0]
                ? item.images[0].startsWith("http")
                  ? item.images[0]
                  : `${item.images[0]}`
                : null;

              const categoryLabel = getCategoryLabel(item);
              const productLink = getProductLink(item);

              return (
                <div
                  key={`${item.type || "product"}-${item.id}-${item.selectedSize?.id || ""}-${item.selectedTexture?.id || ""}`}
                  className="cart-item"
                >
                  {/* IMAGE */}
                  <div className="cart-item-image">
                    {imageUrl ? (
                      <img src={imageUrl} alt={item.name} />
                    ) : (
                      <div className="cart-item-placeholder">✿</div>
                    )}
                  </div>

                  {/* INFO */}
                  <div className="cart-item-info">
                    {productLink ? (
                      <Link to={productLink} className="cart-item-name">
                        {item.name}
                      </Link>
                    ) : (
                      <span className="cart-item-name">{item.name}</span>
                    )}

                    {categoryLabel && <span className="cart-item-category">{categoryLabel}</span>}

                    <span className="cart-item-unit-price">
                      {Number(item.unitPrice || 0).toFixed(0)} ₴ / шт.
                    </span>
                  </div>

                  {/* QUANTITY */}
                  <div className="cart-item-qty">
                    <button
                      disabled={item.quantity <= 1}
                      onClick={() =>
                        updateQuantity(
                          item.id,
                          item.quantity - 1,
                          item.selectedSize?.id,
                          item.selectedTexture?.id
                        )
                      }
                    >
                      −
                    </button>

                    <span>{item.quantity}</span>

                    <button
                      onClick={() =>
                        updateQuantity(
                          item.id,
                          item.quantity + 1,
                          item.selectedSize?.id,
                          item.selectedTexture?.id
                        )
                      }
                    >
                      +
                    </button>
                  </div>

                  {/* TOTAL */}
                  <div className="cart-item-total">
                    {(Number(item.unitPrice || 0) * item.quantity).toFixed(0)} ₴
                  </div>

                  {/* REMOVE */}
                  <button
                    className="cart-item-remove"
                    onClick={() =>
                      removeItem(item.id, item.selectedSize?.id, item.selectedTexture?.id)
                    }
                    aria-label="Видалити"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </div>

          {/* SUMMARY */}
          <div className="cart-summary">
            <h2>Підсумок</h2>

            <div className="summary-rows">
              {cart.map((item) => (
                <div key={`sum-${item.type || "product"}-${item.id}`} className="summary-row">
                  <span>
                    {item.name} × {item.quantity}
                  </span>
                  <span>{(Number(item.unitPrice || 0) * item.quantity).toFixed(0)} ₴</span>
                </div>
              ))}
            </div>

            <div className="summary-divider" />

            <div className="summary-total">
              <span>Разом</span>
              <span>{totalPrice.toFixed(0)} ₴</span>
            </div>

            <Link to="/checkout" className="btn-primary checkout-btn">
              Оформити замовлення →
            </Link>

            <Link to="/catalog" className="continue-shopping">
              ← Продовжити покупки
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
